module.exports = __webpack_public_path__ + "img/solo-brands-annual-pass.ec4f4007.png";